<template>
    <div id="LqsAnalyser">
        <div class="">
            <div class="row datepickerwrap card">
                <div class="col-12 p-0 backBtnWithHeading pb-2 mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="graphHeading mb-0">{{ translatedLang["Schedule ASINs"][selectedLanguage.key] }}</div>
                        <div class="ml-2">
                            <button @click="goBack" style="width: max-content; float: right"
                                class="btn navigationButton" type="button">
                                <i class="fa fa-arrow-left"></i>
                                <span style="font-size: 13px"> {{ translatedLang["Back"][selectedLanguage.key] }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-12 p-0">
                    <div class=" ">
                        <div class="row mb-2">
                            <div class="col-4">
                                <div class="labelHeading">{{ translatedLang["Platform"][selectedLanguage.key] }}</div>
                                <div class="customMultiselectCommon w-100">
                                    <multiselect @input="getLastUpdatedDates()" v-model="selectedChannelForScheule"
                                        :options="platFormListAll || []" :multiple="false" :searchable="false"
                                        track-by="key" label="value" placeholder="Select Platform" :showLabels="false"
                                        :close-on-select="true" :allow-empty="false" class="text-capitalize">
                                    </multiselect>
                                </div>
                            </div>
                            <!-- </div> -->
                            <!-- <div class="row mb-2"> -->
                            <div class="col-4">
                                <div class="labelHeading">{{ translatedLang["Request Name"][selectedLanguage.key] }}</div>
                                <input type="text" placeholder="Enter Request Name" style="width: 100%"
                                    class="customInput" v-model="schedule.requestName" required />
                            </div>
                            <div class="col-4">
                                <div>
                                    <div class="labelHeading">{{ translatedLang["Enter Product ID"][selectedLanguage.key] }}</div>
                                    <div class="d-flex justify-content-start">
                                        <input class="customInput" :placeholder="changeSchedulePlaceholder()"
                                            style="width: 100%" v-model="schedule.ASIN" @keyup="addASIN" />
                                        <!-- <button class="btn primarycolor ml-2" type="button" @click="addASINButton">
                                        <span>+</span>
                                    </button> -->
                                    </div>
                                    <div class="mb-3">
                                        <b-badge pill variant="success" class="mr-1 asinBadge p-1"
                                            v-for="(d, i) in schedule.ASINs" :key="d">
                                            <span>{{ d }}</span>
                                            <b-badge variant="light" @click="removeASIN(i)" class="ml-2 crossIcon"
                                                title="remove">x</b-badge>
                                        </b-badge>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="datebox">
                                    <button class="btn primarycolor" type="button" @click="postLqsBulkSchedule">
                                        <span>{{ translatedLang["submit"][selectedLanguage.key] }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- <ASINResult/> -->
            <div data-html2canvas-ignore="true" class="customdim" v-show="loader || loaderLqsReq">
                <!-- <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div> -->
                <Loader />
            </div>

            <div v-if="selectedChannel === 'flipkart.com'">
                <div class="row px-0" id="LqsAnalyserCardFlipkart" v-show="viewFlipkartLQSCardData.length != 0">
                    <div class="col-md-12 mycols">
                        <div class="datepickerwrap mt-0">
                            <FlipkartLqsCard :viewFSNsDetailedData="viewFlipkartLQSCardData"
                                :storeLqsDataByMonthGroup="storeLqsDataByMonthGroup" ref="childComp"
                                :keyCheck="false" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row" id="LqsAnalyserCard" v-if="viewLqsGraph">
                    <div class="col-md-12 mycols">
                        <div class="card datepickerwrap">
                            <div style="margin: 0" class="space-between">
                                <div class="graphHeading">
                                   {{ translatedLang["Listing Quality Score (LQS) Analysis"][selectedLanguage.key] }}
                                    <span class="textColor">({{ asin }})</span>
                                </div>
                                <div>
                                    <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                        v-if="viewLqsListingdata.product_meta.product_link.includes('www.amazon.in')">
                                        <img src="../../../public/img/IndiaFlag.svg" width="22" class="">
                                        {{ translatedLang["amazon.in"][selectedLanguage.key] }}</span>
                                    <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                        v-if="viewLqsListingdata.product_meta.product_link.includes('www.amazon.com')">
                                        <img src="../../../public/img/USflag.svg" width="22" class="">
                                        {{ translatedLang["amazon.com"][selectedLanguage.key] }}
                                    </span>
                                    <span class="ml-2 screenshot-btn" @click="takeScreenshot"><i
                                            class="fa fa-download cursor-pointer text-primary bg-black px-2 py-1 border border-success rounded"
                                            aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="row p-2">
                                <div class="productCart">
                                    <div class="productImg">
                                        <img :src="viewLqsListingdata.product_meta.product_image" />
                                    </div>
                                    <div class="ml-2">
                                        <a :href="viewLqsListingdata.product_meta.product_link" target="_blanck"
                                            class="cursor-pointer textColor product-title" syte>{{
                                                viewLqsListingdata.product_meta.product_name }}</a>
                                    </div>
                                </div>
                            </div>

                            <div class="row p-2">
                                <div class="col-2">
                                    <div class="border rounded">
                                        <div style="text-align: center">
                                            <highcharts style="width: 100%" :options="gaugeChartData"></highcharts>
                                        </div>
                                        <div class="text-center graphCount">{{ viewLqsGraph }}</div>
                                    </div>
                                </div>
                                <div class="col-10">
                                    <div class="row">
                                        <div class="col-4 sideBorder">
                                            <div class="secondaryHeading mb-2">{{ translatedLang["Copy Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="space-between-header"
                                                v-for="(row, i) in viewLqsListingdata.copy_breakdown"
                                                :key="'lqs_cb' + i">
                                                <div class="textColor" style="text-transform: capitalize">
                                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                        :class="{ falseIcon: row.status == false }"></i>
                                                    {{ row.label }}
                                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                        :title="row.label"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 sideBorder">
                                            <div class="secondaryHeading mb-2">{{ translatedLang["Media Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="space-between-header"
                                                v-for="(row, i) in viewLqsListingdata.media_breakdown"
                                                :key="'lqs_cb' + i">
                                                <div class="textColor" style="text-transform: capitalize">
                                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                        :class="{ falseIcon: row.status == false }"></i>
                                                    {{ row.label }}
                                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                        :title="row.label"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="secondaryHeading mb-2">{{ translatedLang["Review Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="space-between-header"
                                                v-for="(row, i) in viewLqsListingdata.review_breakdown"
                                                :key="'lqs_cb' + i">
                                                <div class="textColor" style="text-transform: capitalize">
                                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                        :class="{ falseIcon: row.status == false }"></i>
                                                    {{ row.label }}
                                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                        :title="row.label"></i>
                                                </div>
                                            </div>
                                            <div class="singatureLogo">
                                                <div style="font-size: 14px" class="text-secondary">{{ translatedLang["Powered By"][selectedLanguage.key] }}</div>
                                                <img src="img/brand/brand_logos/Logos-18.png" width="72" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- request ASINs -->
            <div class="row datepickerwrap card" style="z-index: 0 !important;">
                <div class="col-12 p-0">
                    <div class="space-between reqAsinHeading pb-2 mb-3">
                        <div class="graphHeading">{{ translatedLang["Requested ASINs"][selectedLanguage.key] }}</div>
                        <div class="d-flex  w-full" style="width: 50%; justify-content: end;">
                            <!-- <div class="customSelect mr-2">
                                <select v-model="selectedReqChannel" @change="getLqsRequest(true);"
                                    class="form-control ">
                                    <option value="amazon.in">www.amazon.in</option>
                                    <option value="amazon.com">www.amazon.com</option>
                                    <option value="flipkart.com">flipkart.com</option>
                                </select>
                            </div> -->
                            <div>
                                <date-range-picker v-model="dateRange" opens="left" :autoApply="true"
                                    :locale-data="{ format: 'yyyy-mm-dd' }" @update="dateChange" style="border: none;">
                                </date-range-picker>
                            </div>
                        </div>
                    </div>
                    <div v-if="viewLqsRequestData.data.length && viewLqsRequestDataShow" class="card mt-2"
                        style="padding: 0px !important; ">
                        <table class="" id="lqsTable">
                            <thead>
                                <tr>
                                    <th scope="col" v-for="th of viewLqsRequestData.header" :key="th.key" class="p-2">
                                        {{ th.label }}
                                    </th>
                                    <th v-if="viewLqsRequestData.data">{{ translatedLang["Actions"][selectedLanguage.key] }}</th>
                                </tr>
                            </thead>
                            <tbody v-if="viewLqsRequestData.data.length">
                                <tr class="tr3row" v-for="(row, i) in viewLqsRequestData.data" :key="i">
                                    <td v-for="(d, j) in viewLqsRequestData.header" :key="j">
                                        <div
                                            v-if="d.key == 'request_name' && row.status == 'Success' || row.status == 'failed'">
                                            <router-link v-if="selectedChannelForScheule.key == 'flipkart.com'" :to="'/view-lqs-request/' +
                                                row.request_id +
                                                '/' +
                                                selectedChannelForScheule.key +
                                                '/' +
                                                dateRange.startDate +
                                                '/' +
                                                dateRange.endDate +
                                                '/' +
                                                row.request_name.replace(/\s+/g, '-')
                                                ">
                                                <div class="text-capitalize">{{ row[d.key] }}</div>
                                            </router-link>
                                            <router-link v-else :to="'/view-lqs-request/' +
                                                row.request_id +
                                                '/' +
                                                selectedChannelForScheule.key +
                                                '/' +
                                                dateRange.startDate +
                                                '/' +
                                                dateRange.endDate +
                                                '/' +
                                                row.request_name.replace(/\s+/g, '-')
                                                ">
                                                <div class="text-capitalize">{{ row[d.key] }}</div>
                                            </router-link>
                                        </div>
                                        <!-- <div
                                            v-if="d.key == 'request_name' && row.status == 'Success' || row.status == 'failed'">
                                            <router-link v-if="selectedReqChannel == 'flipkart.com'" :to="'/req-fsns-detailed/' +
                                                row.request_id +
                                                '/' +
                                                dateRange.startDate +
                                                '/' +
                                                dateRange.endDate
                                                ">
                                                <div>{{ row[d.key] }}</div>
                                            </router-link>
                                            <router-link v-else :to="'/req-asins-detailed/' +
                                                row.request_id +
                                                '/' +
                                                dateRange.startDate +
                                                '/' +
                                                dateRange.endDate
                                                ">
                                                <div>{{ row[d.key] }}</div>
                                            </router-link>
                                        </div> -->
                                        <div v-else style="text-transform: capitalize">{{ row[d.key] }}</div>
                                    </td>
                                    <td>
                                        <b-button variant="outline-danger" class="px-3 py-1"
                                            @click="confirmDeleteRequestASIN(row.request_id)"><i
                                                class="fa fa-trash"></i>
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="tr3row">
                                    <td colspan="8" class="text-danger py-2">{{ translatedLang["No Data Available"][selectedLanguage.key] }}.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else-if="!viewLqsRequestDataShow && loaderLqsReq" class="onLoadingData m-2">{{ translatedLang["Loading"][selectedLanguage.key] }}...</div>
                    <div v-else
                        class="text-danger m-2 d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
                        {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
                    </div>
                </div>
            </div>
        </div>
        <b-modal title="Delete Requested ASIN" v-model="deleteRequestModal" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <div>{{ translatedLang["delete this request ASIN"][selectedLanguage.key] }}.<br>{{ translatedLang["Are you sure"][selectedLanguage.key] }}</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="closeConfirmModal" class="btn primarycolor">{{ translatedLang["No"][selectedLanguage.key] }}, {{ translatedLang["Keep It"][selectedLanguage.key] }}.</b-button>
                <button @click="deleteRequestASIN" :disabled="deleteRequestLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-requestBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="deleteRequestLoader"></b-spinner>
                    <span>{{ translatedLang["Yes"][selectedLanguage.key] }}, {{ translatedLang["Delete"][selectedLanguage.key] }}!</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import html2canvas from 'html2canvas';
// import MyProducts from "./MyProducts.vue";
import FlipkartLqsCard from "./Flipkart/FlipkartLqsCard.vue";
import Loader from "../Components/Loader.vue";
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";

export default {
    name: "LqsSchedule",
    components: { LqsCard, Datepicker, Multiselect, FlipkartLqsCard, Loader },

    data: function () {
        return {
            gaugeChartData: {},
            viewLqsListingdata: [],
            platFormListAll: [],
            inputSearchkey: "",
            viewLqsGraph: "",
            loader: false,
            loaderLqsReq: true,
            viewLqsRequestDataShow: false,
            asin: "",
            fsn: "",
            isInputEmpty: false,
            isScheduleOpen: true,
            isMyASINDataOpen: false,
            schedule: {
                email: localStorage.getItem('loginUserEmail'),
                ASIN: "",
                ASINs: [],
                requestName: ''
            },
            viewMyASINsData: {},
            viewLqsRequestData: { data: [] },
            dateRange: {
                startDate: moment().subtract(1, "month"),
                endDate: moment(),
            },
            selectedChannel: sessionStorage.getItem('productSelectedChannel') == null ? { key: "amazon.in", value: "Amazon Retail" } : sessionStorage.getItem('productSelectedChannel'),
            selectedChannelForScheule: sessionStorage.getItem('scheduleSelectedChannel') == null ? { key: "amazon.in", value: "Amazon Retail" } : sessionStorage.getItem('scheduleSelectedChannel'),

            selectedReqChannel: 'amazon.in',
            intervalId: null,
            deleteRequestModal: false,
            storeDeleteRequestId: [],
            deleteRequestLoader: false,
            customClient: JSON.parse(localStorage.reviewUserData).data.client,
            viewFlipkartLQSCardData: [],
            storeLqsDataByMonthGroup: null,
            totalCountValue: null
        };
    },

    mounted() {
        if (localStorage.storeAllPlatformListDataForLqs) {
            this.platFormListAll = JSON.parse(localStorage.storeAllPlatformListDataForLqs);
            this.selectedChannelForScheule = sessionStorage.getItem('scheduleSelectedChannel') == null ? this.platFormListAll[0] : JSON.parse(sessionStorage.getItem('scheduleSelectedChannel'));
        }
        this.dataAPIs();

    },
    watch: {
        selectedChannelForScheule: {
            handler(newValue) {
                sessionStorage.setItem('scheduleSelectedChannel', JSON.stringify(newValue));
            },
            deep: true
        }
    },
    computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
    methods: {
        ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
        checkStatus() {
            this.intervalId = setInterval(() => {
                this.getLqsRequest(false)
            }, 10000);
        },
        destroyInterval() {
            if (this.viewLqsRequestData.data[0].status == 'Success' || this.viewLqsRequestData.data[0].status == 'failed') {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }

        },


        dataAPIs() {
            this.formatDates();
            this.getLastUpdatedDates();
        },
        formatDates() {
            this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        },

        dateChange() {
            this.formatDates();
            this.getLqsRequest(true);
        },

        changePlaceholder() {
            let temp = 'Enter Product '
            temp += this.selectedChannel == 'flipkart.com' ? 'FSN/URL' : 'ASIN/URL'
            return temp
        },

        changeSchedulePlaceholder() {
            const ASIN = 'Enter Product ID (press enter for multiple products)'
            const FSN = 'Enter Product ID (press enter for multiple products)'
            return (this.selectedChannelForScheule.key == 'flipkart.com' ? FSN : ASIN)
        },

        // addASIN() {
        //     let data = this.schedule.ASIN.trim();
        //     if (event.key != "Enter" || !data.length) {
        //         return false;
        //     }
        //     if (this.selectedChannelForScheule == 'flipkart.com') {
        //         if (data.length != 16) {
        //             alert("Please enter vaild FSN");
        //             return false
        //         }
        //         if (!this.schedule.ASINs.includes(data)) {
        //             this.schedule.ASINs.push(data);
        //             this.schedule.ASIN = "";
        //         }
        //         else {
        //             alert("Please enter different FSN")
        //         }
        //     }
        //     else {
        //         if (!this.validASIN(data)) {
        //             alert("please enter vaild ASIN");
        //             return false
        //         }
        //         if (!this.schedule.ASINs.includes(data)) {
        //             this.schedule.ASINs.push(data);
        //             this.schedule.ASIN = "";
        //         }
        //         else {
        //             alert("Please enter different ASIN")
        //         }
        //     }
        // },

        addASIN() {
            let data = this.schedule.ASIN.trim();

            if (event.key !== "Enter" || !data.length) {
                return false;
            }

            let asinList = data.split(',').map(asin => asin.trim());

            asinList.forEach((asin) => {
                if (this.selectedChannelForScheule.key === 'flipkart.com') {
                    if (asin.length !== 16) {
                        alert("Please enter a valid FSN (16 characters)");
                        return false;
                    }
                    if (!this.schedule.ASINs.includes(asin)) {
                        this.schedule.ASINs.push(asin);
                    } else {
                        alert(`FSN ${asin} is already added. Please enter a different FSN.`);
                    }
                } else {
                    if (!this.validASIN(asin)) {
                        alert(`Please enter a valid ASIN (${asin})`);
                        return false;
                    }
                    if (!this.schedule.ASINs.includes(asin)) {
                        this.schedule.ASINs.push(asin);
                    } else {
                        alert(`ASIN ${asin} is already added. Please enter a different ASIN.`);
                    }
                }
            });

            this.schedule.ASIN = "";
        },



        addASINButton() {
            let data = this.schedule.ASIN.trim();
            if (this.selectedChannelForScheule.key == 'flipkart.com') {
                if (data.length != 16) {
                    alert("Please enter vaild FSN");
                    return false
                }
                if (!this.schedule.ASINs.includes(data)) {
                    this.schedule.ASINs.push(data);
                    this.schedule.ASIN = "";
                }
                else {
                    alert("Please enter different FSN")
                }
            }
            else {
                if (!this.validASIN(data)) {
                    alert("please enter vaild ASIN");
                    return false
                }
                if (!this.schedule.ASINs.includes(data)) {
                    this.schedule.ASINs.push(data);
                    this.schedule.ASIN = "";
                }
                else {
                    alert("Please enter different ASIN")
                }
            }
        },
        removeASIN(i) {
            this.schedule.ASINs.splice(i, 1);
        },

        // delete ASIN request
        confirmDeleteRequestASIN(reqId) {
            this.storeDeleteRequestId = []
            this.storeDeleteRequestId.push(reqId);
            this.deleteRequestModal = true;
        },

        closeConfirmModal() {
            this.storeDeleteRequestId = []
            this.deleteRequestModal = false;
        },

        deleteRequestASIN() {
            // pending
            let self = this;
            self.loader = false;
            self.deleteRequestLoader = true
            let payload = {
                job_ids: this.storeDeleteRequestId,
                channel: this.selectedChannelForScheule.key
            };
            const url = "/api/v2/spider/deleterequests";
            self.$http
                .post(url, payload)
                .then((response) => {
                    self.deleteRequestLoader = false;
                    this.deleteRequestModal = false;
                    self.getLqsRequest(false);
                    self.storeDeleteRequestId = []
                    self.loader = false;
                    this.$bvToast.toast(response.data.data.message, {
                        title: response.data.data.summary,
                        autoHideDelay: 3000,
                        variant: "success"
                    });
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },

        toggleScheduleForm() {
            this.isScheduleOpen = !this.isScheduleOpen;
        },

        toggleMyASINData() {
            this.isMyASINDataOpen = !this.isMyASINDataOpen;
        },

        changeInputState() {
            this.isInputEmpty = false;
        },

        async takeScreenshot() {
            let self = this
            let id = "#LqsAnalyserCard";
            let uniqueCardId = document.querySelector(id);
            let getScreenshotDiv = uniqueCardId.querySelector('.screenshot-btn');
            getScreenshotDiv.classList.add('screenshot-hide-btn');
            html2canvas(uniqueCardId, { useCORS: true }).then(function (canvas) {
                canvas.style.display = "none"
                document.body.appendChild(canvas);
                const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                const a = document.createElement("a");
                a.setAttribute("download", `Weavr-LQS-${self.asinData}.png`);
                a.setAttribute("href", image);
                a.click();
                getScreenshotDiv.classList.remove('screenshot-hide-btn');
            });
        },
        getLqsRequest(loader) {
            let self = this;
            self.loaderLqsReq = loader;
            let payload = {
                start: this.dateRange.startDate,
                end: this.dateRange.endDate,
                client: this.customClient,
                channel: this.selectedChannelForScheule.key,
                language: this.$store.state.DemoStore.selectedLanguage.key,
            };
            const url = "/api/v2/spider/viewrequest";
            self.$http
                .post(url, payload)
                .then((response) => {
                    // if(Object.keys(response.data.data.data).length)
                    self.viewLqsRequestDataShow = response.data.data_present;
                    self.loaderLqsReq = false;
                    self.viewLqsRequestData = response.data.data;
                    self.destroyInterval();
                })
                .catch((err) => {
                    self.viewLqsRequestDataShow = false
                    this.$bvToast.toast(response.data.data.message, {
                        title: response.data.data.summary,
                        autoHideDelay: 3000,
                        variant: "warning"
                    });
                    self.loaderLqsReq = false;
                    console.log("err");
                });
        },

        goBack() {
            window.history.back();
        },

        getLastUpdatedDates() {
            this.loader = true;
            const url = '/api/v2/spider/lqs_last_update';
            const payload = {
                client: this.customClient,
                channel: this.selectedChannelForScheule.key
            }
            this.$http.post(url, payload).then(
                (response) => {
                    if (response.body.data.data) {
                        const input = response.body.data.data
                        const [date, time] = input.split(" ")
                        this.dateRange.endDate = moment(date).format("YYYY-MM-DD");
                        this.dateRange.startDate = moment(date).subtract(1, "month").format("YYYY-MM-DD")
                    }
                    else {
                        this.dateRange.endDate = moment().format('YYYY-MM-DD');
                        this.dateRange.startDate = moment().subtract(1, "month").format("YYYY-MM-DD")
                    }
                    this.getLqsRequest(true);
                    this.loader = false;
                },
                (err) => {
                    this.loader = false;
                    // this.refresh()
                }
            );
        },

        postLqsBulkSchedule() {
            let self = this;
            this.loader = true
            if (!this.schedule.requestName) {
                alert("Enter request name");
                this.loader = false;
                return false

            }
            // if (!this.validEmail(this.schedule.email) || !this.schedule.email) {
            //     alert("E-mail id incorrect");
            //     this.loader = false;
            //     return false;
            // }

            if (this.schedule.ASIN) {
                if (this.selectedChannelForScheule.key == 'flipkart.com') {
                    if (this.schedule.ASIN.length != 16) {

                        alert("Please enter vaild FSN sdsd");
                        this.loader = false;
                        return false
                    }
                    else {
                        this.schedule.ASINs.push(this.schedule.ASIN);
                    }
                }
                else {
                    if (this.validASIN(this.schedule.ASIN)) {
                        if (!this.schedule.ASINs.includes(this.schedule.ASIN)) {
                            this.schedule.ASINs.push(this.schedule.ASIN);
                        }
                    } else {
                        alert("Please enter vaild ASIN");
                        this.loader = false;
                        return false
                    }
                    if (!this.validASIN(this.schedule.ASIN) && this.schedule.ASINs.length == 0) {
                        alert("Please enter vaild ASIN");
                        this.loader = false;
                        return false
                    }
                }
            }

            // else if()
            // self.loader = true;
            let payload = {
                email: self.schedule.email,
                client: self.customClient,
                request_name: self.schedule.requestName,
                channel: self.selectedChannelForScheule.key,
            };
            // console.log("check tdh payload", payload,this.schedule.ASINs)
            let url = "";
            if (this.selectedChannelForScheule.key == 'flipkart.com') {
                url = "api/v2/spider/flipkart_lqs_request_bulk"
                payload.fsn_id = self.schedule.ASINs
            }
            else {
                url = '/api/v2/spider/lqsschedulerNew'
                payload.asin_id = self.schedule.ASINs
            }
            // console.log("check the payload", payload)
            self.$http
                .post(url, payload)
                .then((response) => {
                    self.getLqsRequest(true);
                    self.schedule.ASIN = '',
                        self.schedule.requestName = ''
                    self.schedule.ASINs = [];
                    self.schedule.email = [];
                    self.checkStatus();
                    self.loader = false;
                    alert("Success");
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        validASIN(ASIN) {
            var isASIN = /^(B[0-9A-Z]{2}\d{7}|[0-9A-Z]{10})$/;
            return isASIN.test(ASIN);
        },

        isValidURL(url) {
            const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;;
            return regex.test(url);
        },

        getPidFromUrl(url) {
            // Create a URL object from the input URL
            const urlObj = new URL(url);
            // Use URLSearchParams to get the value of the 'pid' parameter
            const params = new URLSearchParams(urlObj.search);
            const pid = params.get('pid');

            // Return the pid value
            return pid;
        },

        getASINFromUrl(url) {
            const asinRegex = /\/([A-Z0-9]{10})(?:[/?]|$)/i;
            const match = url.match(asinRegex);
            if (match && match.length > 1) {
                return match[1];
            }
            return false;
        },

        getLqsListingData() {
            let self = this;
            let tempInputSearchKey = this.inputSearchkey
            if (!this.inputSearchkey) {
                self.isInputEmpty = true;
                return false;
            }

            if (this.selectedChannel == 'flipkart.com') {
                if (this.isValidURL(this.inputSearchkey)) {
                    tempInputSearchKey = this.getPidFromUrl(this.inputSearchkey)
                }
                else if (this.inputSearchkey.length != 16) {
                    alert("Please enter vaild FSN");
                    return false
                }
                else {
                    // alert("Please enter valid product URL/FSN")
                }
            }
            else {
                if (this.isValidURL(this.inputSearchkey)) {
                    tempInputSearchKey = this.getASINFromUrl(this.inputSearchkey)
                }
                else if (!this.validASIN(this.inputSearchkey)) {
                    alert("Please enter vaild ASIN");
                    return false
                }
                else {
                    // alert("Please enter valid product URL/ASIN")
                }
            }
            self.loader = true;
            self.viewLqsListingdata = {};
            self.viewLqsGraph = "";
            self.viewFlipkartLQSCardData = '';
            self.asin = tempInputSearchKey;
            self.fsn = tempInputSearchKey;
            let payload = {
                client: self.customClient
            };

            let url = '';

            if (self.selectedChannel != 'flipkart.com') {
                payload.channel = self.selectedChannel;
                payload.asin_id = tempInputSearchKey;
                url = "/api/v2/spider/lqsstatus";
            }
            else {
                url = '/api/v2/spider/flipkart_lqs_request'
                payload.fsn_id = tempInputSearchKey;
            }
            self.$http
                .post(url, payload)
                .then((response) => {
                    // if (Object.keys(response.data.data.data).length)
                    if (this.selectedChannel == 'flipkart.com' && response.data.data) {
                        self.viewFlipkartLQSCardData = response.data.data.data;
                        this.storeLqsDataByMonthGroup = null;
                        this.storeLqsDataByMonthGroup = this.sortAndGroupByMonth(response.data.data.data.slice(1));
                        // this.totalCountValue = response.data.data.data[0].total;
                        this.$refs.childComp.gaugeChart(response.data.data.data[0].total);
                    }
                    else {
                        self.viewLqsListingdata = response.data.data.data.lqs_analysis;
                        self.viewLqsGraph = response.data.data.data.total;
                        this.gaugeChart();
                    }

                    self.loader = false;
                })
                .catch((err) => {
                    this.$bvToast.toast('Technical Error!', {
                        title: 'Error!',
                        autoHideDelay: 3000,
                        variant: "danger"
                    });
                    self.loader = false;

                    console.log("err");
                });
        },


        sortAndGroupByMonth(data) {
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            data.forEach(item => {
                const date = new Date(item.timestamp);
                item.monthIndex = date.getMonth();
            });
            data.sort((a, b) => a.monthIndex - b.monthIndex);
            const groupedData = {};
            data.forEach(item => {
                const monthName = monthNames[item.monthIndex];
                if (!groupedData[monthName]) {
                    groupedData[monthName] = [];
                }
                groupedData[monthName].push(item);
            });
            return groupedData;
        },

        chartHeight() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 250
        },

        chartSize() {
            if (window.screen.width < 1400) {
                return 280
            }
            else
                return 400
        },

        gaugeChart() {
            let self = this;
            this.gaugeChartData = {
                chart: {
                    type: "gauge",
                    plotBackgroundImage: null,
                    height: this.chartHeight(),
                },

                title: {
                    text: "Listing Quality Score ",
                },
                credits: {
                    enabled: false,
                },
                pane: [
                    {
                        startAngle: -45,
                        endAngle: 45,
                        background: null,
                        center: ["50%", "120%"],
                        size: this.chartSize(),
                    },
                ],

                exporting: {
                    enabled: false,
                },

                tooltip: {
                    enabled: false,
                },

                yAxis: [
                    {
                        min: 0,
                        max: 10,
                        minorTickPosition: "outside",
                        tickPosition: "outside",
                        labels: {
                            rotation: "auto",
                            distance: 10,
                        },
                        plotBands: [
                            {
                                from: 0,
                                to: 10,
                                color: {
                                    stops: [
                                        [0, "#fd6b2d"], //yellow
                                        [1, "#55BF3B"], //green
                                    ],
                                },
                                innerRadius: "90%",
                                outerRadius: "100%",
                            },
                            {
                                from: 0,
                                to: 4,
                                color: "#FF786B", // red
                                thickness: 20,
                            },
                            {
                                from: 4,
                                to: 8,
                                color: "#667BFE", // blue
                                thickness: 20,
                            },
                            {
                                from: 8,
                                to: 10,
                                color: "#42D9BC", // green
                                thickness: 20,
                            },
                        ],
                        pane: 0,
                        title: {
                            text: "",
                            y: 0,
                        },
                    },
                ],

                plotOptions: {
                    gauge: {
                        dataLabels: {
                            enabled: false,
                        },
                        dial: {
                            radius: "100%",
                        },
                    },
                },

                series: [
                    {
                        name: "Ratting",
                        data: [self.viewLqsGraph],
                        yAxis: 0,
                    },
                ],
            };
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
select option {
    text-transform: capitalize;
    padding: 10px 0px;
}

select {
    font-family: "Poppins", sans-serif;
}

.customSelect select {
    border: 1px solid rgb(228, 231, 234) !important;
    height: 35px;
    border-radius: 5px !important;

}

.customSelect :focus {
    background: var(--base_color-5);
    color: var(--primary_brand-60);
    border: 1px solid var(--primary_brand-60) !important;
    outline: none;
    box-shadow: none;
    font-weight: 600;
}

.screenshot-btn {
    transition: .4s linear !important;
    cursor: pointer;
}

.cursor-pointer {
    cursor-pointer: pointer !important;
}

.screenshot-btn .fa-download {
    color: var(--primary_brand) !important
}

.screenshot-btn:hover {
    background-color: #F2F1F6;
}

.screenshot-hide-btn {
    visibility: hidden;
}

.space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flex-start {
    display: flex;
    justify-content: start;
}

.mainHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1.3125rem;
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.textColor {
    color: #818890 !important;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.inputBox {
    height: 30px;
    border: 1px solid silver;
    display: flex;
    justify-content: start;
    background: white;
}

.inputBox input {
    border-radius: 0px;
    border: none !important;
}

.sideBorder {
    border-right: 1px solid #c1c1c1;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}

.errorMassage {
    color: #ff0000 !important;
    font-family: "poppins";
    font-size: 11px;
    margin-top: 5px;
}

.cardButton {
    margin-left: 10px;
}

.productCart {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.productImg {
    width: 200px;
}

.product-title {
    font-size: 18px;
}

.productImg img {
    width: 100%;
}

.graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
}

.asinBadge {
    /* background: '#9683b3'; */
    background: "#9683b3";
}

.cross-icon {
    color: black;
    background: white;
}

.crossIcon {
    cursor: pointer;
    font-size: 8px;
}

/* .space-between {
    display: flex;
    justify-content: space-between;
} */

thead {
    font-family: "poppins" !important;
    background: none !important;
    color: #4e4e4e !important;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
    color: black;
}

tbody {
    font-family: "poppins" !important;
    font-size: 13px;
}

.pinkColor {
    background: rgb(255 185 185);
    font-weight: bold;
}

.skyColor {
    background: rgb(199 224 255);
    font-weight: bold;
}

.no-data {
    font-size: 16px;
    text-align: center;
    padding: 10px;
    color: var(--red);
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 18px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid rgb(228, 231, 234);
    width: 220px;
    outline: none;
}

.danger {
    border: 1px solid var(--red);
    color: var(--red) !important;
    height: 35px !important;
    width: 220px;
    background-color: var(--red-20);
    border-radius: 5px !important;
}

.danger:focus {
    border: 1px solid var(--red) !important;
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
}

.customInput::placeholder {
    color: var(--primary_brand-40);
}

#lqsTable {
    --border: 1px solid var(--base_color-20);
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    overflow: hidden;
}

#lqsTable th:not(:last-child),
#lqsTable td:not(:last-child) {
    border-right: var(--border) !important;
}

#lqsTable>tbody>tr:not(:last-child)>td {
    border-bottom: var(--border) !important;
}

#lqsTable th {
    background: #06555914 !important;
    padding: 0.6rem !important;
    font-size: 14px !important;
    border-bottom: var(--border) !important;
    font-family: "Poppins", sans-serif !important;
    color: #5e5e5e !important;
    font-weight: 600;
}

#lqsTable td {
    padding: 4px !important;
    font-size: 14px !important;
    font-family: "Heebo", sans-serif !important;
    color: #5e5e5e !important;
    font-weight: 400 !important;
}

.singatureLogo {
    position: absolute;
    bottom: 20px;
    right: 20px;
    text-align: center !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.delete-requestBtn:hover {
    background-color: #f58181 !important;
}
</style>
<style>
/* modal */
/* .modal-title {
	font-weight: 400 !important;
	font-family: "poppins" !important;
	border-bottom: 1px solid #D5D5D5 !important;
	padding-bottom: 15px;
	color: #5E5E5E !important;
	font-size: 16px;
}

.modal-header {
    background: var(--primary_brand-20) !important;
    color: var(--base_color);
    border: none;
    font-family: "poppins";
    border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
    color: black !important;
    text-shadow: none !important;
    position: absolute !important;
    top: -2px;
    right: -6px;
    font-size: 30px;
    background: var(--primary_brand-10);
    opacity: inherit;
    padding: 5px 10px;
    border-radius: 25px;
} */

.modal-delete-content {
    color: var(--primary_brand);
    font-size: 16px;
    margin-bottom: 5px;
    font-family: "poppins";
}

.btn-outline-danger:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: red !important;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80) !important;
    color: white;
}

.reqAsinHeading,
.backBtnWithHeading {
    border-bottom: 1px solid #D5D5D5;
}

.labelHeading {
    font-size: 14px !important;
    color: #000;
    margin-bottom: 8px;
}

.from-control {
    font-size: 12 !important;
}
</style>
